module.exports = __webpack_public_path__ + "img/no-available-icon.1cd08c75.svg";